// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LgwD","largestCol":"styles_largestCol__1w-Zj","smallestCol":"styles_smallestCol__3wwF_"};